module.exports = __webpack_public_path__ + "img/sld_scb_7_t1_green.ad18e33a.svg";